import React, { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { auth } from "utils/firebase";
import { userOnboardingStage } from "app/types";
import { selectLoginForm } from "../../redux/selector";
import { validateLoginForm } from "../../helpers";
import { actions as appActions } from "app/redux/slice";
import { actions } from "../../redux/slice";
import { selectUserFormData } from "app/redux/selector";

export const useLogin = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const loginForm = useSelector(selectLoginForm);
  const userFormData = useSelector(selectUserFormData);

  React.useEffect(() => {
    const token = localStorage.getItem("accessToken");
    if (token && userFormData.userOnboardingProgress) {
      userLoginRedirection(userFormData.userOnboardingProgress);
    }
  }, [navigate, userFormData.userOnboardingProgress]);

  const userLoginRedirection = (key: userOnboardingStage) => {
    switch (key) {
      case userOnboardingStage.CREATE_PROFILE:
        return navigate("/onboarding/create-profile");
      case userOnboardingStage.CREATE_TEAM:
        return navigate("/onboarding/team");
      case userOnboardingStage.ON_BOARDING_INFO:
        return navigate("/onboarding/setup");
      case userOnboardingStage.COMPLETED:
        return navigate("/app/home");
      default:
        return navigate("/auth/login");
    }
  };

  const handleSubmit = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    const errors = validateLoginForm(loginForm);
    if (errors.length > 0) {
      dispatch(actions.setLoginFormErrors(errors));
      return;
    }
    dispatch(
      actions.loginRequest({
        callback(nextPage) {
          dispatch(actions.clearLoginForm());
          dispatch(appActions.doGetMyProfile());
          userLoginRedirection(nextPage);
          if (nextPage === userOnboardingStage.COMPLETED) {
            dispatch(appActions.doGetUserWorkspace({ callback() {} }));
          }
        },
      })
    );
  };

  const isDisabled = useCallback(
    () => !loginForm.email.value || !loginForm.password.value,
    [loginForm.email.value, loginForm.password.value]
  );

  React.useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((user: any) => {
      if (user) {
        // responseGoogle could also be extracted if needed
      }
    });
    return () => unsubscribe();
  }, []);

  return { handleSubmit, isDisabled };
};
